module.exports = __webpack_public_path__ + "media/icons/arrow-left-f84b2d2a.svg";